import User from "@/models/User";
import UserClaims from "@/models/UserClaims";
import {store} from "../index";

const fb = require('@/firebase/config.js');

fb.fire.auth().onAuthStateChanged((user) => {
    if (user) {
        console.log('Auto sign in user from store')
        console.log(user.uid)
        store.dispatch('user/autoSignIn', user)
            .then(() => {

                fb.fire.analytics().setUserId(user.uid);

                fb.auth.currentUser.getIdTokenResult()
                    .then(tokenResult => {
                        console.log('claims', tokenResult.claims);
                        store.commit('user/setUserClaims', {user: user, roles: tokenResult.claims});
                    })

                Promise.all([
                    // store.dispatch('getUserProfile'),
                    // store.dispatch('getUserSubscriptions')
                ])
                    .catch((error) => {
                        console.log('error!!!!!', error)
                    })
                    .finally(() => {
                        console.log('promise all finally')
                        store.commit('setInitApp', true);
                    })


            })
    } else {
        console.log('Auto sign in user from store, no user found!')
        store.commit('setInitApp', true);
        //store.dispatch('logout');

        fb.fire.auth().signInAnonymously()
            .then((user) => {
                console.log(user);
            })
            .catch((error) => {
                console.log(error)
            })
    }
})


export default {
    namespaced: true,
    state: {
        loggedin: false,
        user: new User(),
        claims: new UserClaims()
    },

    getters: {
        isAnonymous(state) {
            return state.user && state.user.isAnonymous
        }
    },

    mutations: {
        setUser(state, payload) {
            state.user = (payload == null) ? new User() : payload;
            state.loggedin = (payload != null) ? true : false;
        },
        setUserClaims(state, payload) {
            state.claims = (payload == null) ? new UserClaims() : payload;
        },
    },

    actions: {
        autoSignIn({commit}, payload) {
            console.log(commit, payload);

            return new Promise((resolve) => {

                let user = new User();
                user.uid = payload.uid;
                user.displayName = payload.displayName;
                user.photoUrl = payload.photoUrl;
                user.email = payload.email;
                user.emailVerified = payload.emailVerified;
                user.fulldata = payload;
                user.isAnonymous = payload.isAnonymous;

                commit('setUser', user);
                resolve();
            });
        },
        setUser({commit}, newUser) {
            console.log('action setuser ', newUser)
            commit('setUser', newUser)
        },
        signUserIn({commit}, payload) {
            return new Promise((resolve, reject) => {
                fb.auth.signInWithEmailAndPassword(payload.email, payload.password)
                    .then(
                        user => {
                            user = user.user

                            // const u = new User();
                            // u.displayName = user.displayName;
                            // u.email = user.email;
                            // u.uid = user.uid;
                            // u.photoUrl = user.photoURL;
                            // u.emailVerified = user.emailVerified;
                            // u.fulldata = user;
                            //
                            // console.log('login user:')
                            //
                            // commit('setUser', u);

                            fb.auth.currentUser.getIdTokenResult()
                                .then(tokenResult => {
                                    console.log(tokenResult.claims);
                                    commit('setUserClaims', {user: user, roles: tokenResult.claims});
                                })

                            resolve(user);
                        }
                    )
                    .catch(
                        error => {
                            console.log(error)
                            reject(error);
                        }
                    )
            });
        },
        logout() {
            fb.auth.signOut()
        }
    }
}